'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _OrganisationModel = require('../model/OrganisationModel');

var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _PickerControl = require('../../../lib/ui/PickerControl');

var _PickerControl2 = _interopRequireDefault(_PickerControl);

var _ImageSelectControl = require('../../../lib/ui/ImageSelectControl');

var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);

var _SelectLocation = require('../../location/action/SelectLocation');

var _SelectLocation2 = _interopRequireDefault(_SelectLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganisationForm = function () {
  function OrganisationForm(element, args) {
    var _this = this;

    _classCallCheck(this, OrganisationForm);

    var fieldsetOrganisation = document.createElement('fieldset');
    var legendOrganisation = document.createElement('legend');
    legendOrganisation.innerHTML = 'Organisatie';
    fieldsetOrganisation.appendChild(legendOrganisation);
    var popup = null;
    this.id = args.organisation.values.id;
    this.image = new _ImageSelectControl2.default(fieldsetOrganisation, { label: 'Afbeelding', value: args.organisation.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
    this.name = new _TextControl2.default(fieldsetOrganisation, { label: 'Naam', value: args.organisation.values.name, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
    this.location = new _PickerControl2.default(fieldsetOrganisation, { label: 'Hoofdvestiging', value: args.organisation.values.location_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectLocation2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.location.setValue(item.values.id, item);
            } else {
              _this.location.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.location.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.vat = new _TextControl2.default(fieldsetOrganisation, { label: 'BTW nummer', value: args.organisation.values.vat, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
    this.coc = new _TextControl2.default(fieldsetOrganisation, { label: 'KVK nummer', value: args.organisation.values.coc, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetOrganisation);

    element.appendChild(fragment);
  }

  _createClass(OrganisationForm, [{
    key: 'getValue',
    value: function getValue() {
      var organisation = new _OrganisationModel2.default();
      organisation.values.image = this.image.getValue();
      organisation.location = this.location.getItem();
      organisation.values.id = this.id;
      organisation.values.name = this.name.getValue();
      organisation.values.location_id = this.location.getValue();
      organisation.values.vat = this.vat.getValue();
      organisation.values.coc = this.coc.getValue();
      return organisation;
    }
  }, {
    key: 'setValue',
    value: function setValue(organisation) {
      this.id = organisation.values.id;
      this.image.setValue(organisation.values.image);
      this.name.setValue(organisation.values.name);
      this.location.setValue(organisation.values.location_id, organisation.location);
      this.vat.setValue(organisation.values.vat);
      this.coc.setValue(organisation.values.coc);
    }
  }]);

  return OrganisationForm;
}();

exports.default = OrganisationForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/organisation/ui/OrganisationForm.js
// module id = 61
// module chunks = 0